import Vue from 'vue'
export function arrayToObject(array) {
    let object = {}
    for (let index = 0; index < array.length; index++) {
        const element = array[index];
        Vue.set(object, element.key, element.value)
    }
    return object
}